module.exports = __webpack_public_path__ + "static/media/group3-mobile.ca591a70.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/group3-mobile.svg
// module id = 1360
// module chunks = 0